import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { pageResetMiddleWare, zodOptionalId, zodPage, zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const labPharmacyListRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/pharmacy_lists/$id',
  params: z.object({ id: zodPathParamId }),
  validateSearch: z.object({
    groupId: zodOptionalId,
    query: z.string().optional(),
    page: zodPage,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/lab/PharmacyLists/LabPharmacyListPage/LabPharmacyListPage').then((d) => d.Route)
);
